import { getOfferHref, getOfferValueLabel } from './deals.js';

function cleanString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function mapListingDetailOffers(offers = []) {
  return (Array.isArray(offers) ? offers : [])
    .map((offer) => {
      const title = cleanString(offer?.title);
      if (!title) return null;

      return {
        id: cleanString(offer?.id) || cleanString(offer?.slug) || title,
        title,
        description: cleanString(offer?.shortDescription)
          || cleanString(offer?.fullDescription)
          || 'Open this deal to view details and redemption instructions.',
        badge: getOfferValueLabel(offer),
        href: getOfferHref(offer),
      };
    })
    .filter(Boolean);
}
